<ion-header>
  <ion-toolbar color="primary">
    
    <ion-buttons slot="start">
      <ion-back-button routerDirection="back" data-cy="scheduler-hdr-backBtn"></ion-back-button>
      <ion-menu-button class="ionMenuButtonCls" autoHide="true"></ion-menu-button>
    </ion-buttons>

    <ion-buttons slot="end">
      <app-profile-component (click)="openMyProfile()"></app-profile-component>
    </ion-buttons>
    <ion-title>Scheduler</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div>
    <div class="content">
      <label class="current-listing-title">
        <div class="address">Schedule for {{ listing?.address?.title }}</div>
        <ion-button (click)="openSchedulingInfo()" class="info-btn" fill="clear" mode="md" size="small">
          <ion-icon slot="icon-only" name="information-circle-sharp" />
        </ion-button>
      </label>
      <div class="buttons">
        <ion-button class="add-time-btn" shape="round" size="small" (click)="addNewEmptyEvent()">
          <ion-icon name="add-outline"></ion-icon>
          Add Open House
        </ion-button>
      </div>

      <div class="block">
        <open-house-scheduler
          #calendar
          [mode]="'admin'"
          [listing]="listing"
          (onEventsChange)="eventsChanged($event)"
        />
      </div>

      <div *ngIf="agentsWithScheduledEvents.length > 0" class="block">
        <div class="title">
          <div>{{ agentsWithScheduledEvents.length }} Scheduled Agent{{ agentsWithScheduledEvents.length === 1 ? '' : 's' }}</div>
        </div>

        <div *ngIf="agentsWithScheduledEvents.length" class="chips-container">
          <div
            class="agent"
            *ngFor="let agentsWithEvents of agentsWithScheduledEvents"
          >
            <app-public-profile-item
              [agentsOpenHouseEvents]="agentsWithEvents.events"
              [pairedAgentData]="agentsWithEvents.agent"
              [showControls]="false"
              [showInvite]="false"
              [showContact]="false"
              [showSocial]="false"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</ion-content>
